






import Vue from 'vue';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import { ErrorModel, NotificationPresentationType } from '@/types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'ErrorPage',
  props: {
    errorCode: {
      type: [String, Number],
      required: false
    },
    errorMessage: {
      type: String,
      required: false
    },
    notificationPresentationType: {
      type: [String, Number],
      required: false,
      default: NotificationPresentationType.UnexpectedError
    }
  },
  data(this: any) {
    return {
      errorModel: {
        header: '',
        showHeader: true,
        message: this.errorDescription,
        icon: 'exclamation-triangle',
        iconTheme: this.errorIconTheme,
        showButton: true,
        buttonRouteName: 'DefaultRoute',
        buttonText: 'Go Back'
      } as ErrorModel
    };
  },
  methods: {
    extend(this: any) {
      clearInterval(this.nowIntervalId);
      this.$emit('extend');
    }
  },
  components: {
    ErrorNotification
  },
  computed: {
    ...mapGetters('userStore', ['errorPageRoute']),
    errorDescription(): string {
      return `${this.errorCode} - ${this.errorMessage}`;
    },
    errorIconTheme(this: any): string {
      return +this.notificationPresentationType === NotificationPresentationType.UnexpectedError
        ? 'text-danger'
        : 'text-secondary';
    }
  },
  mounted(this: any) {
    const errorPageRoute = this.errorPageRoute.lastRoute;
    this.errorModel.message = this.errorDescription;
    this.errorModel.iconTheme = this.errorIconTheme;
    if (errorPageRoute.name != null) {
      this.errorModel.buttonRouteName = errorPageRoute.name;
      this.errorModel.buttonRouteParams = errorPageRoute.params;
    }
  }
});
